<template>
  <dialogTemplate
    :widthDialog="'500px'"
    :modalAppendToBody="true"
    :appendToBody="true"
    :openDialog="openDialog"
    :classDialog="'dialogRedirect'"
    :showCloseBtn="false"
  >
    <template #body>
      <div class="flex-row flex__left">
        <i
          alt=""
          class="dialogIcon fas fa-exclamation-triangle color__yellow"
        ></i>
        <h3 class="dialogTitle margin-left-5">WARNING !</h3>
      </div>
      <div>
        <p>{{ content }}</p>
        <p>Hệ thống sẽ tự động chuyển trang trong {{ countDown_ }} giây ...</p>
        <br/>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__center form-button__action">
        <el-button class="bg__yellow color__white" @click="backToLogin">
          Chuyển trang
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>

  export default {
    name: "DialogHandlerErrorV2",
    components: {
      dialogTemplate: () => import("./../views/common/custom-dialog.vue")
    },

    props: ["content", "openDialog", "title", "countDown"],

    data() {
      return {
        countDown_: 10
      };
    },

    watch: {
      countDown(newValue) {
        this.countDown_ = newValue || 10;
      }
    },

    created() {
      this.countDown_ = this.countDown || 10;
      this.subCountDown();
    },

    methods: {
      backToLogin() {
        this.$emit('redirect');
      },

      subCountDown() {
        setInterval(() => {
          if (this.countDown_ > 1) {
            this.countDown_ -= 1;
          } else {
            this.backToLogin();
            this.countDown_ -= 1;
          }
        }, 1000);
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/DialogHandlerErrorV2.vue